import { render, staticRenderFns } from "./xyPopup.vue?vue&type=template&id=665b52cc&scoped=true&"
import script from "./xyPopup.vue?vue&type=script&lang=js&"
export * from "./xyPopup.vue?vue&type=script&lang=js&"
import style0 from "./xyPopup.vue?vue&type=style&index=0&id=665b52cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b52cc",
  null
  
)

export default component.exports